<div class="tab-list">
	<slot></slot>
</div>

<style>
	.tab-list {
		border-bottom: 1px solid #d2d2d2;
		padding: 0 8%;
	}
</style>